const topicItems = [
  { tag: '#长安十二时辰剧情解析', hot: '9.8万讨论' },
  { tag: '#国产科幻电影推荐', hot: '7.2万讨论' },
  { tag: '#今年最好看的动漫', hot: '6.5万讨论' },
  { tag: '#周末宅家追剧指南', hot: '5.8万讨论' },
  { tag: '#综艺名场面盘点', hot: '5.3万讨论' },
  { tag: '#韩剧甜到牙疼系列', hot: '4.9万讨论' },
  { tag: '#悬疑片结局大揭秘', hot: '4.2万讨论' },
  { tag: '#纪录片里的震撼世界', hot: '3.6万讨论' },
  { tag: '#童年经典动画片回忆', hot: '3.1万讨论' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-24 bg-gray-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-black text-gray-900">热门话题</h2>
            <p className="text-sm text-gray-500 mt-2">大家都在讨论什么？加入热门话题</p>
          </div>

          <div className="flex flex-wrap justify-center gap-3">
            {topicItems.map((item, idx) => (
              <div
                key={idx}
                className="group bg-white rounded-full px-5 py-3 border border-gray-200 hover:border-brand-300 hover:bg-brand-50 transition-all duration-300 cursor-pointer flex items-center gap-3"
              >
                <span className="text-sm font-semibold text-gray-700 group-hover:text-brand-600 transition-colors whitespace-nowrap">{item.tag}</span>
                <span className="text-xs text-gray-400 group-hover:text-brand-400 transition-colors whitespace-nowrap">{item.hot}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}